/**
 * DF-478: the date customers are asked to have their Christmas changes in by,
 * as the Christmas email says. It's guidance only: the portal still accepts
 * changes up to each delivery's real cut-off (DF-473). Shown in the "More
 * info" pop-up for a day in the Christmas schedule. Empty to show the real
 * cut-offs instead.
 */
export const CHRISTMAS_CHANGES_BY = '11 December'
